import { Injectable } from "@angular/core";

import { BaseService } from "../abstracts/base.service";
import { AddressModel } from "../models/address.model";
import { ParentModel } from "../models/parent.model";
import { ResultModel } from "../models/result.model";
@Injectable({
  providedIn: "root",
})
export class ParentService extends BaseService {


  listAllForSelect(studentID: string = null) {
    if(studentID){
      return this.httpClient.get<ResultModel<ParentModel[]>>(this.getApiUrl(`parents?pStudentID=${studentID}`));
    }
    else{
      return this.httpClient.get<ResultModel<ParentModel[]>>(this.getApiUrl('parents'));
    }
  }

  listAll(formData?: FormData) {
    return this.httpClient.post<ResultModel<ParentModel[]>>(this.getApiUrl("parents/list"), formData);
  }

  create(parent: ParentModel, address: AddressModel) {

    if (this.getQueryString(address) == "") {
      return this.httpClient.post<ResultModel>(this.getApiUrl("parents"), parent);
    }
    else {
      return this.httpClient.post<ResultModel>(this.getApiUrl("parents?" + this.getQueryString(address)), parent);
    }
  }

  update(parent: ParentModel, address?: AddressModel) {

    if (this.getQueryString(address) == "") {
      return this.httpClient.put(this.getApiUrl("parents"), parent);
    }
    else {
      return this.httpClient.put(this.getApiUrl("parents?" + this.getQueryString(address)), parent);
    }
  }


  get(id: string) {
    return this.httpClient.get<{ Parent: ParentModel, Address: AddressModel }>(this.getApiUrl("parents/" + id));
  }

  delete(id: string) {
    return this.httpClient.delete<ResultModel>(this.getApiUrl("parents/" + id));
  }
}
